/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Oauth_DenyInputs */



/**
* | output |
* | --- |
* | "Deny" |
*
* @param {Oauth_DenyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_deny = /** @type {((inputs?: Oauth_DenyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_DenyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Refuser")
	if (locale === "es") return /** @type {LocalizedString} */ ("Denegar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Negar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nega")
	return /** @type {LocalizedString} */ ("Deny")
});